import CampaignVisibilityInsightsPage from "@faire/prototype-playground/workspace/va/campaign-visibility-insights";
import { Route, Switch } from "react-router-dom";

export function VarunAppaswamiRoutes() {
  return (
    <Switch>
      <Route
        path="/va/campaign-visibility-insights"
        component={CampaignVisibilityInsightsPage}
      />
    </Switch>
  );
}

export const slug = "va";
